<template>
    <div class="popup popup-shorex" :class="{ 'modal-in': isShow, 'modal-out': !isShow}"  id="shorexDetail" >
        <div class="shorexDetail-title js-returnShorexBtn">
            <p>岸上观光服务</p>
            <a class="shorexDetail-returnButton" @click="goBack()">
                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png">
            </a>
        </div>
        <div class="shorexDetail">
            <div class="shorexDetail-container" v-if="hasShorex">
                <div class="shorexDetail-wrap">
                    <div class="shoreTrip-tab ">
                        <div v-if="shorexInfo.payShorex.length > 0" class="shoreTrip-tab-item shorex-tab-pay js-tab"
                            :class="{ 'active': activeTab == 'payShorex'}"
                            @click="activeTab='payShorex'"
                            data-el="shoreTripM0-cell00"
                            data-box="shoreTripM">
                            <p class="shoreTrip-tab-item-txt1 ">皇家精品游（付费）</p>
                        </div>
                        <div v-if="shorexInfo.freeShorex && shorexInfo.freeShorex.length > 0" class="shoreTrip-tab-item shorex-tab-free js-tab "
                            :class="{ 'active': activeTab == 'freeShorex'}"
                             @click="activeTab='freeShorex'"
                            data-el="shoreTripM0-cell00"
                            data-box="shoreTripM">
                            <p class="shoreTrip-tab-item-txt1 shoreTrip-tab-item-txt3">皇家常规游（免费）</p>
                        </div>
                    </div>
                    <div class="shoreTrip-m" v-show="activeTab=='payShorex'">
                        <div class="tab-cell active shorex-tab-pay-item" v-for="(shorex, i) in shorexInfo.payShorex" :key="('payShorex'+i)">
                            <div class="shoreTrip-box">
                                <div class="shoreTrip-box-title">
                                    <div class="shoreTrip-box-title-line"></div>
                                    {{shorex.shorexName}}
                                </div>
                              <div style="width: 100%">
                                <ShorexSwiper :banner-list="shorex.bannerList"></ShorexSwiper>
                              </div>
                                <p class="shorexBrief-css">{{shorex.shorexBrief}}</p>
                                <p class="shorexPrice-css">
                                    <img class="time-css" v-if="shorex.duration && shorex.duration.length > 0"
                                        src="https://resource.rcclchina.com.cn/RcclHP/time-jpg.jpg">时长:{{shorex.duration}}
                                    <img class="img-price-css" v-if="shorex.shorexPrice && shorex.shorexPrice.length > 0"
                                        src="https://resource.rcclchina.com.cn/RcclHP/price-jpg.jpg">价格:{{shorex.shorexPrice}} 美金/人</p>
                                <div class="shorex-content" v-html="shorex.shorexDescription"></div>
                                <div class="shorex-content" v-html="shorex.introWarningText"></div>
                            </div>
                        </div>
                        <div class="shoreTrip-box tab-cell active shorex-tab-pay-item">
                            <div class="popupover2-txt2 shoreTrip-box-popupover2-txt1">
                                注：<br>

                                1) 船票支付成功后，您可选订皇家精品游（付费）；均数量有限，先到先得。如不选订任何行程则视为自助游，您需自行安排目的地游览行程。<br/>
                                2) 目的地的产品及行程仅供参考，实际行程以具体航次和地接社安排为准。<br/>
                                3) 目的地产品及行程可能受天气、航次情况、交通、政府政策及/或保护公共健康安全之相关要求而取消、变更或调整。<br/>
                                4) 皇家行前订目前只提供全程观光套餐，您可于登船后购买单一港口观光产品，全程套餐与单一港口观光产品均数量有限，先到先得。
                            </div>
                        </div>
                    </div>

                    <div class="shoreTrip-m" v-show="activeTab=='freeShorex'">
                        <div class="tab-cell shorex-tab-free-item" v-for="(shorex, i) in shorexInfo.freeShorex" :key="('freeShorex' + i)">
                            <div class="shoreTrip-box">
                                <div class="shoreTrip-box-title" style="">
                                    <div class="shoreTrip-box-title-line"></div>
                                    {{shorex.shorexName}} - {{shorex.duration}}
                                </div>
                                <div class="shorex-content" v-html="shorex.shorexDescription"></div>
                                <div class="shorex-content" v-html="shorex.introWarningText"></div>
                            </div>

                            <div class="tab-cell   shoreTrip-box shorex-tab-free-item">
                                <div class="popupover2-txt2 shoreTrip-box-popupover2-txt1">
                                    注：<br>

                                  1) 船票支付成功后，您可选订皇家精品游（付费）；均数量有限，先到先得。如不选订任何行程则视为自助游，您需自行安排目的地游览行程。<br/>
                                  2) 目的地的产品及行程仅供参考，实际行程以具体航次和地接社安排为准。<br/>
                                  3) 目的地产品及行程可能受天气、航次情况、交通、政府政策及/或保护公共健康安全之相关要求而取消、变更或调整。<br/>
                                  4) 皇家行前订目前只提供全程观光套餐，您可于登船后购买单一港口观光产品，全程套餐与单一港口观光产品均数量有限，先到先得。
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
            <div class="shorexDetail-container" v-else>
                <img class="noData" src="https://resource.rcclchina.com.cn/cruiseDetail/shorexCompTour/noShorex.png" alt="">
                <p class="shorex-empty" :class="{'isPayShorexOnly': shorexInfo.payShorexOnly}">
                  <img src="https://resource.rcclchina.com.cn/cruiseDetail/shorexCompTour/noShorexTextIcon.png" alt="">
                  <span v-html="payShorexOnlyStr"></span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import ShorexSwiper from "@/components/Booking/ShorexSwiper.vue";
export default {
    name: 'ShorexInfoPopup',
    components: {
      ShorexSwiper
    },
    props: {
        onGoBack: {
            type: Function
        },
        isShow: {
            type: Boolean,
            default () {
                return false
            }
        },
        shorexInfo: {
            type: Object,
            default() {
                return {
                    freeShorex: [],
                    payShorex: [],
                    payShorexOnly: false
                }
            }
        }
    },
    data () {
        return {
          activeTab: 'payShorex',
          swiperOptions: {
            pagination: {
              el: ".swiper-pagination",
            },
            loop: false,
            autoplay: {
              delay: 5000,
            },
          },
          payShorexOnlyStr: ""
        }
    },
    methods: {
        goBack () {
            this.onGoBack()
        },
        onSlideChange(){
          //   获取所有class为video-content下的视频
          const videoList = document.querySelectorAll('.video-content video')
          videoList.forEach(item=>{
            item.pause()
          })
        }
    },
    computed: {
        hasShorex() {
            return this.shorexInfo && (
                (this.shorexInfo.freeShorex && this.shorexInfo.freeShorex.length > 0)
            || (this.shorexInfo.payShorex && this.shorexInfo.payShorex.length > 0)
            )
        }
    },
    watch: {
        shorexInfo (newShorexInfo) {
            if (newShorexInfo.payShorex && newShorexInfo.payShorex.length > 0) {
                this.activeTab = 'payShorex'
            } else if (newShorexInfo.freeShorex && newShorexInfo.freeShorex.length > 0) {
                this.activeTab = 'freeShorex'
            } else {
                this.activeTab = ''
            }
            if (newShorexInfo.payShorexOnly) {
              this.payShorexOnlyStr = "该航次岸上观光精品游行程（付费）尚未开放选订，<br>选订开放后，我们会在第一时间通知您，<br>您也可以密切关注皇家加勒比官方网站。";
            } else {
              this.payShorexOnlyStr = "该航次岸上观光服务尚未开放选订，选订开放后，<br>我们会在第一时间通知您，<br>您也可以密切关注皇家加勒比官方网站。";
            }
        }
    }
}
</script>

<style lang="less" scoped>
#shorexDetail.popup {
    position: fixed;
    background-color: #F6F7F8;
    transform: translate3d(100%, 0, 0);
    display: block;
    z-index: 10401;
}
#shorexDetail.modal-in {
    position: fixed;
    background-color: #F6F7F8;
    transform: translate3d(0, 0, 0);
}
#shorexDetail.modal-out {
    transform: translate3d(100%, 0, 0);
}

#shorexDetail {
    .shorexDetail-title {
        padding: 15px 20px;
        background-color: #fff;
        overflow: hidden;
        text-align: center;
        margin-bottom: 10px;
        position: fixed;
        width: 100%;
        z-index: 10;
        > p {
            
            font-size: 14px;
            color: #333333;
            letter-spacing: 1px;
            text-align: center;
            margin: 0;
        }
        .shorexDetail-returnButton {
            width: 30px;
            position: absolute;
            top: 15px;
            left: 20px;
            text-align: left;
            > img {
                width: 33%;
            }
        }
    }

    .shorexDetail {
        height: 100%;
        overflow: scroll;
        margin-top: 50px;
        padding-bottom: 50px;
        background-color: #f6f7f8;
        .shorexDetail-container {
            .shoreTrip-tab {
                -webkit-box-flex: 0;
                -webkit-flex: none;
                -moz-box-flex: 0;
                -ms-flex: none;
                flex: none;
                position: relative;
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                margin-top: 10px;
                background: #FFFFFF;
                -webkit-box-shadow: 0 1px 2px 1px rgba(0,0,0,0.05);
                box-shadow: 0 1px 2px 1px rgba(0,0,0,0.05);
                overflow: hidden;
                .shoreTrip-tab-item {
                    -webkit-box-flex: 1;
                    -webkit-flex: 1;
                    -moz-box-flex: 1;
                    -ms-flex: 1;
                    flex: 1;
                    position: relative;
                    display: -webkit-box;
                    display: -webkit-flex;
                    display: -moz-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-orient: vertical;
                    -webkit-box-direction: normal;
                    -webkit-flex-direction: column;
                    -moz-box-orient: vertical;
                    -moz-box-direction: normal;
                    -ms-flex-direction: column;
                    flex-direction: column;
                    -webkit-box-align: center;
                    -webkit-align-items: center;
                    -moz-box-align: center;
                    -ms-flex-align: center;
                    align-items: center;
                    -webkit-box-pack: center;
                    -webkit-justify-content: center;
                    -moz-box-pack: center;
                    -ms-flex-pack: center;
                    justify-content: center;
                    height: 43px;
                    font-size: 10px;
                    line-height: 14px;
                    color: #666;
                    text-align: center;
                    background: #FFFFFF;
                    border-top-left-radius: 9px;
                    p {
                        margin: 0;
                        font-size: 13px;
                    }
                }
                .shoreTrip-tab-item:first-child {
                    border-top-left-radius: 0;
                    border-bottom-right-radius: 9px;
                }
                .shoreTrip-tab-item.active {
                    z-index: 2;
                    color: #fff;
                    background-color: #4A90E2;
                }
            }

            .shoreTrip-m {
                -webkit-box-flex: 1;
                -webkit-flex: 1;
                -moz-box-flex: 1;
                -ms-flex: 1;
                flex: 1;
                overflow-y: auto;
                padding-top: 2px;
                .shoreTrip-box {
                    margin-bottom: 10px;
                    padding: 0 20px 18px;
                    font-size: 12px;
                    line-height: 20px;
                    color: #666;
                    background-color: #fff;
                    p {
                        margin: 0;
                    }
                    img {
                        display: block;
                        width: 100%;
                        height: 100%;
                        margin-bottom: 15px;
                    }
                    .shoreTrip-box-title {
                        display: -webkit-box;
                        display: -webkit-flex;
                        display: -moz-box;
                        display: -ms-flexbox;
                        display: flex;
                        -webkit-box-align: center;
                        -webkit-align-items: center;
                        -moz-box-align: center;
                        -ms-flex-align: center;
                        align-items: center;
                        height: 40px;
                        font-size: 12px;
                        line-height: 16px;
                        color: #4A90E2;
                        font-weight: bold;
                        .shoreTrip-box-title-line {
                            width: 3px;
                            height: 12px;
                            margin-right: 5px;
                            background-color: #4A90E2;
                        }
                    }
                    .shoreTrip-box img {
                        display: block;
                        width: 100%;
                        margin-bottom: 15px;
                    }
                    .shorexBrief-css {
                        font-size: 12px;
                        color: #333333;
                        letter-spacing: 1px;
                        font-weight: bold;
                    }
                    p.shorexPrice-css {
                        font-size: 12px;
                        color: #4A90E2;
                        letter-spacing: 0;
                        line-height: 20px;
                        margin-bottom: 5px;
                        img {
                            width: 12px;
                            height: 12px;
                            display: inline-block;
                            margin-bottom: -1px;
                            margin-right: 3px;
                        }
                        .img-price-css {
                            margin-right: 7px;
                            margin-left: 15px;
                        }
                    }

                }
            }

            .popupover2-txt2 {
                font-size: 12px;
                line-height: 20px;
                color: #666;
                padding-top: 10px;
            }
            .noData{
              width: 127px;
              height: 92px;
              display: block;
              margin: 30px auto 0;
            }
        }
    }

    .shorex-empty {
        margin: 25px auto;
        font-size: 12px;
        display: flex;
        text-align: center;
        justify-content: center;
        gap: 3px;
        color: #313131;
        position: relative;
        padding-left: 20px;
        img{
          width: 15px;
          height: 15px;
          display: block;
          position: absolute;
          top: 2px;
          left: 45px;
        }
        &.isPayShorexOnly {
          img{
            left: 40px;
          }
        }
    }
}

</style>

<style lang="less">
.shorex-content, .shorex-content p, .shorex-content span {
    // font-size: 12px !important;
   // color: #666 !important;
}
.shorex-content p {
    margin: 0 !important;
}
</style>
